import type { FaireProductEntity } from "../../entity_types/product";

export const ramen_10: FaireProductEntity = {
  token: "ramen-10",
  type: "product",
  name: "Woon Mama's Way Hot Sauce",
  brandName: "Woon",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/58e0988461b76b0725bd240221b6e07fb7f6c0f355df5323f7a650031ab9f9d6.png",
  priceDollars: 27.5,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/58e0988461b76b0725bd240221b6e07fb7f6c0f355df5323f7a650031ab9f9d6.png",
  weight: 0.5,
  dimensions: {
    width: 3,
    height: 6,
    depth: 3,
  },
  description: "Woon Mama's way hot sauce for ramen",
  categoryTokens: ["cat_food-snacks"],
  tags: ["ramen", "japanese-ramen", "hot-sauce", "condiment", "premium"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
